import React from 'react';
import { LeadForm } from '../../components/LeadForm';
export function CommerceHeroForm() {
  return <div className="bg-paper p-8 rounded-2xl shadow-2xl border border-subtle-gray relative" data-id="element-738">
      <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-storm-red text-white px-6 py-2 rounded-full font-bold uppercase tracking-wide whitespace-nowrap shadow-lg" data-id="element-739">
        Find Your Class or Program
      </div>
      <div className="mt-4" data-id="element-740">
        <LeadForm buttonText="Check Availability" data-id="element-741" />
      </div>
    </div>;
}